module.exports = __webpack_public_path__ + "static/media/tommySleeveHood3.0ff0cb9d.svg";